/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { ErrorMessage } from '@hookform/error-message';
import useListenSize from '../hooks/useListenSize';
import phoneMask from '../helpers/phoneMask';
import phoneUnMask from '../helpers/phoneUnMask';
import getLLEsubdomain from '../helpers/getLLEsubdomain';
import {
  addPhoneWithMask,
  setNewUserFlow,
  setReturnUserFlow,
  setCheckoutLookupData,
  setupFeatureGates,
  setShopifySessionId,
  setShopifyOrgId,
} from '../redux/actions';
import SubmitButton from '../components/SubmitButton';
import Sidebar from '../components/Sidebar';

function NewUserFlow({ onDataChange }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();

  const store = useSelector(state => ({
    shopify: state.technical?.shopify,
    instoreVccFlow: state.technical?.instoreVccFlow,
  }));
  const isInstoreVccFlow = Boolean(store.instoreVccFlow?.isInstoreVccFlow);

  const [isMobileSidebarVisibe, setMobileSidebarVisibe] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [retailerToken, setRetailerToken] = useState('');
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  useListenSize();

  const lleDomain = getLLEsubdomain('dash');
  const host = window.location?.host;
  const isLLE = host?.includes('sandbox') || host?.includes('qa02') || host?.includes('preprod');
  let checkoutLookupUrl = 'https://shpfy.katapult.com/api/v1/checkout_lookup';
  if (isLLE) {
    checkoutLookupUrl = `https://${lleDomain}shopify-payment-api.katapult.com/api/v1/checkout_lookup`;
  }

  async function getCheckoutLookupData(url, data) {
    const response = await fetch(url, {
      method: 'POST',
      headers: new Headers({
        'content-type': 'application/json',
      }),
      body: JSON.stringify(data),
    });
    const checkoutData = await response?.json();
    return checkoutData;
  }

  async function loadRetailerFeatureGates(token) {
    try {
      const endpoint = `https://${getLLEsubdomain('dot')}katapult.com/api/ng/zibbyjs/retailer/detail/`;
      const response = await fetch(endpoint, {
        method: 'get',
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }),
      });
      if (response.ok) {
        const data = await response.json();
        dispatch(setupFeatureGates(data.feature_gates));
      }
    } catch (error) {
      console.log('error: ', error);
    }
  }

  // In-store VCC has no Shopify checkout: the retailer public token from /instore/location/ is the retailer token.
  useEffect(() => {
    if (isInstoreVccFlow && store.instoreVccFlow?.publicToken) {
      setRetailerToken(store.instoreVccFlow.publicToken);
      loadRetailerFeatureGates(store.instoreVccFlow.publicToken).catch(() => {});
    }
  }, [isInstoreVccFlow, store.instoreVccFlow?.publicToken]);

  useEffect(() => {
    if (isInstoreVccFlow) {
      return;
    }
    const getCheckoutLookup = async () => {
      const checkoutResponse = await getCheckoutLookupData(checkoutLookupUrl, {
        transaction_id: store.shopify?.transactionId,
      });
      dispatch(setCheckoutLookupData(checkoutResponse));
      setRetailerToken(checkoutResponse?.retailer_token);
      onDataChange(checkoutResponse?.checkout_object);

      await loadRetailerFeatureGates(checkoutResponse?.retailer_token);
    };
    getCheckoutLookup();
  }, []);

  const onMobileSidebarClick = () => {
    setMobileSidebarVisibe(!isMobileSidebarVisibe);
  };

  const onPhoneChange = event => {
    const result = phoneMask(event.target?.value);
    setPhoneNumber(result);
  };

  const onSubmit = async event => {
    dispatch(addPhoneWithMask(event?.phone));
    if (window.top) {
      window.top.postMessage({ message: `phone-${phoneUnMask(event?.phone)}` }, window.location.origin);
    }
    setLoading(true);

    try {
      const endpoint = `https://${getLLEsubdomain('dot')}katapult.com/api/v3/user/auth/retailer/`;
      const response = await fetch(endpoint, {
        method: 'post',
        headers: new Headers({
          Authorization: `Bearer ${retailerToken}`,
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({ phone: phoneUnMask(event?.phone) }),
      });
      if (response.ok) {
        const data = await response.json();
        const sessionEndpoint = `https://${getLLEsubdomain('dot')}katapult.com/api/sessionid/?phone=${phoneUnMask(
          event?.phone,
        )}`;
        // eslint-disable-next-line camelcase
        const user_agent = navigator.userAgent;
        // eslint-disable-next-line camelcase
        const screen_resolution = `${window.screen.width}x${window.screen.height}`;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const language = navigator.language;
        const sessionParams = {
          user_agent,
          screen_resolution,
          timezone,
          language,
        };
        const sessionRes = await fetch(sessionEndpoint, {
          method: 'post',
          headers: new Headers({
            Authorization: `Bearer ${retailerToken}`,
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify({ phone: phoneUnMask(event?.phone), ...sessionParams }),
        });
        const sessionData = await sessionRes.json();

        dispatch(setShopifySessionId(sessionData.threatmetrix_session_id));
        dispatch(setShopifyOrgId(sessionData.org_id));
        window.threatmetrix?.profile(
          'tmx.katapult.com',
          sessionData?.org_id,
          sessionData?.threatmetrix_session_id,
          2000,
        );
        console.log('loaded 2000');
        if (data.new_user) {
          dispatch(setNewUserFlow(true));
          dispatch(setReturnUserFlow(false));
          window.threatmetrix?.profile(
            'tmx.katapult.com',
            sessionData?.org_id,
            sessionData?.threatmetrix_session_id,
            2001,
          );
          console.log('loaded 2001');
        } else {
          dispatch(setNewUserFlow(false));
          dispatch(setReturnUserFlow(true));
          window.threatmetrix?.profile(
            'tmx.katapult.com',
            sessionData?.org_id,
            sessionData?.threatmetrix_session_id,
            2100,
          );
          console.log('loaded 2100');
        }
        history.push('/return-user-flow');
      }
    } catch (error) {
      console.log('error: ', error);
      history.push('/error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="k-content-wrapper">
      <section
        className="k-mobile-sidebar"
        onClick={onMobileSidebarClick}
        onKeyDown={onMobileSidebarClick}
        role="button"
        tabIndex={0}
      >
        <div className={`k-mobile-sidebar-text ${isMobileSidebarVisibe ? 'k-mobile-sidebar-opened' : ''}`}>
          {isMobileSidebarVisibe ? 'Tap to hide' : 'Tap to learn more'}
        </div>
        {isMobileSidebarVisibe && (
          <div className="k-mobile-sidebar-content">
            <Sidebar />
          </div>
        )}
      </section>
      <section className="k-info synchrony-top-section">
        <h1 className="synchrony-main-title k-shopify-header">Enter your mobile number</h1>
      </section>
      <section className="k-info k-new-user-subtitle">
        <span className="k-new-user-subtitle-text">
          We&apos;ll text you a verification code to start or resume your application (standard SMS charges may apply)
        </span>
      </section>
      <section className="k-form k-form-indent">
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <div className="k-field animate__animated animate__fadeInDown">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="phone">Mobile number</label>
            <input
              type="tel"
              name="phone"
              value={phoneNumber}
              maxLength="14"
              id="phone"
              autoComplete="off"
              placeholder="123-456-7890"
              data-testid="phone"
              className="new-user-flow-phone"
              {...register('phone', {
                required: 'This is required',
                onChange: e => {
                  onPhoneChange(e);
                },
                pattern: {
                  value: /^\(\d{3}\)\s\d{3}-\d{4}/,
                  message: 'Should be 10 numeric digits ',
                },
              })}
            />
            <div className="k-form-validation-message">
              <ErrorMessage errors={errors} name="phone" render={({ message }) => message} />
            </div>
          </div>
          <div>
            <section className="synchrony-terms">
              <input
                type="checkbox"
                name="terms"
                id="terms"
                {...register('terms', {
                  required: 'This is required',
                })}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="terms" className="synchrony-terms-label" data-testid="terms">
                By checking this box, I confirm that I have read, understand, and consent to the{' '}
                <a href="https://katapult.com/app/credit-disclosure" rel="noreferrer" target="_blank">
                  Credit Report Disclosures
                </a>
                ,{' '}
                <a href="https://katapult.com/app/privacy-policy" rel="noreferrer" target="_blank">
                  Privacy Policy
                </a>
                ,{' '}
                <a href="https://katapult.com/app/esign-disclosure" rel="noreferrer" target="_blank">
                  ESIGN Disclosure
                </a>
                , and{' '}
                <a href="https://katapult.com/app/terms-of-use" rel="noreferrer" target="_blank">
                  Terms of Use
                </a>
                , which contain a binding arbitration agreement. If declined by Katapult, I consent to my application
                being submitted to Katapult affiliates Aaron&apos;s, LLC and Community Choice Financial, Inc. (the
                &quot;Authorized Entities&quot;) and for the Authorized Entities to obtain and use consumer reports
                about me in connection with my application(s). I agree that Katapult and the Authorized Entities may
                contact me by text, SMS, and MMS for login info and other application and account-related information. I
                understand that message &amp; data rates may apply and that message frequency may vary.
              </label>
            </section>
            <div className="k-form-validation-message">
              <ErrorMessage errors={errors} name="terms" render={({ message }) => message} />
            </div>
          </div>
          <SubmitButton loading={loading} disabled={isInstoreVccFlow && !retailerToken} />
        </form>
      </section>
    </div>
  );
}

export default NewUserFlow;
